import * as React from 'react';
import { SVGProps } from 'react';

const SvgStatusInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg width={80} height={80} viewBox="0 0 80 80" fill="none" role="img" {...props}>
    <circle cx={40} cy={40} r={40} fill="#E9F9FB" />
    <rect x={8} y={8} width={64} height={64} rx={32} fill="#fff" />
    <mask id="a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Zm-2.487-19.385a2.385 2.385 0 0 0 4.77 0V41.179a2.385 2.385 0 1 0-4.77 0v11.436ZM39.963 25C38.342 25 37 26.314 37 27.936c0 1.62 1.341 2.935 2.962 2.935 1.65 0 3.004-1.36 2.962-3.01-.04-1.591-1.368-2.861-2.96-2.861Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 72c17.673 0 32-14.327 32-32C72 22.327 57.673 8 40 8 22.327 8 8 22.327 8 40c0 17.673 14.327 32 32 32Zm-2.487-19.385a2.385 2.385 0 0 0 4.77 0V41.179a2.385 2.385 0 1 0-4.77 0v11.436ZM39.963 25C38.342 25 37 26.314 37 27.936c0 1.62 1.341 2.935 2.962 2.935 1.65 0 3.004-1.36 2.962-3.01-.04-1.591-1.368-2.861-2.96-2.861Z"
      fill="#6AD5E5"
    />
    <path
      d="m42.925 27.862-2 .05 2-.05ZM70 40c0 16.569-13.431 30-30 30v4c18.778 0 34-15.222 34-34h-4ZM40 10c16.569 0 30 13.431 30 30h4C74 21.222 58.778 6 40 6v4ZM10 40c0-16.569 13.431-30 30-30V6C21.222 6 6 21.222 6 40h4Zm30 30c-16.569 0-30-13.431-30-30H6c0 18.778 15.222 34 34 34v-4Zm-.102-17a.385.385 0 0 1-.385-.385h-4A4.385 4.385 0 0 0 39.898 57v-4Zm.385-.385a.385.385 0 0 1-.385.385v4a4.385 4.385 0 0 0 4.385-4.385h-4Zm0-11.436v11.436h4V41.179h-4Zm-.385-.385c.213 0 .385.173.385.385h4a4.385 4.385 0 0 0-4.385-4.385v4Zm-.385.385c0-.212.173-.385.385-.385v-4a4.385 4.385 0 0 0-4.385 4.385h4Zm0 11.436V41.179h-4v11.436h4ZM39 27.935c0-.492.422-.935.963-.935v-4C37.262 23 35 25.185 35 27.936h4Zm.962.936c-.54 0-.962-.442-.962-.935h-4c0 2.749 2.26 4.935 4.962 4.935v-4Zm.963-.959c.013.501-.412.959-.963.959v4c2.75 0 5.032-2.261 4.962-5.06l-3.999.101ZM39.963 27c.531 0 .95.428.962.912l3.999-.1c-.068-2.7-2.307-4.812-4.96-4.812v4Z"
      fill="#fff"
      mask="url(#a)"
    />
  </svg>
);

export default SvgStatusInfo;
